import React, { useState } from 'react';
import { Linkedin, MessageCircle, Link2, Check, Share2 } from 'lucide-react';
import { toast } from 'sonner';
import { isMobileDevice } from './FloatingWhatsAppButton';
import { useLanguage } from '../i18n/LanguageContext';

const linkedinShare = (url) => `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
const whatsappShare = (text, url) => {
  const msg = encodeURIComponent(`${text}\n${url}`);
  return isMobileDevice() ? `https://wa.me/?text=${msg}` : `https://web.whatsapp.com/send?text=${msg}`;
};

export const ShareButtons = ({ title, compact = false }) => {
  const { t } = useLanguage();
  const [copied, setCopied] = useState(false);
  const url = typeof window !== 'undefined' ? window.location.href : '';

  const copyLink = async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const ta = document.createElement('textarea');
        ta.value = url; ta.style.position = 'fixed'; ta.style.opacity = '0';
        document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
      }
      setCopied(true);
      toast.success(t('blog.linkCopied'));
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt(t('blog.copyLink'), url);
    }
  };

  const btn = 'inline-flex items-center gap-2 rounded-full border-2 px-4 py-2 text-sm font-medium transition-colors';

  return (
    <div className={`flex flex-wrap items-center gap-3 ${compact ? '' : 'bg-gray-50 border border-gray-200 rounded-2xl p-5'}`} data-testid="share-buttons">
      <span className="inline-flex items-center gap-2 text-sm font-semibold text-gray-700 mr-1">
        <Share2 className="w-4 h-4 text-[#8B2C3A]" />
        {t('blog.share')}
      </span>
      <a
        href={linkedinShare(url)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="share-linkedin"
        className={`${btn} border-[#0A66C2] text-[#0A66C2] hover:bg-[#0A66C2] hover:text-white`}
      >
        <Linkedin className="w-4 h-4" /> LinkedIn
      </a>
      <a
        href={whatsappShare(title, url)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="share-whatsapp"
        className={`${btn} border-[#25D366] text-[#128C7E] hover:bg-[#25D366] hover:text-white`}
      >
        <MessageCircle className="w-4 h-4" /> WhatsApp
      </a>
      <button
        type="button"
        onClick={copyLink}
        data-testid="share-copy-link"
        className={`${btn} border-gray-300 text-gray-700 hover:border-[#8B2C3A] hover:text-[#8B2C3A]`}
      >
        {copied ? <Check className="w-4 h-4 text-emerald-600" /> : <Link2 className="w-4 h-4" />}
        {copied ? t('blog.linkCopied') : t('blog.copyLink')}
      </button>
    </div>
  );
};
